export default "__VITE_PUBLIC_ASSET__a7a1d551__"